import gql from 'graphql-tag';

const DELETE_MARKETING_ONLY_NOTE = gql` 
  mutation deleteMarketingOnlyNote($input: MarketingOnlyNoteDeleteInput!) {
    deleteMarketingOnlyNote(input: $input) {
      message
      code
    }
  }
`;

export default DELETE_MARKETING_ONLY_NOTE;